module.exports = __webpack_public_path__ + "img/logo.e19892e6.svg";